var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdLocationIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.53555 8.48526L5 12L1.46445 8.48526C0.76519 7.79011 0.288992 6.90444 0.0960713 5.94025C-0.0968497 4.97606 0.00217047 3.97664 0.38061 3.0684C0.75905 2.16015 1.39991 1.38386 2.22216 0.837687C3.0444 0.291517 4.0111 0 5 0C5.9889 0 6.9556 0.291517 7.77784 0.837687C8.60009 1.38386 9.24095 2.16015 9.61939 3.0684C9.99783 3.97664 10.0969 4.97606 9.90393 5.94025C9.71101 6.90444 9.23481 7.79011 8.53555 8.48526ZM5 6.07509C5.29468 6.07509 5.5773 5.95871 5.78567 5.75157C5.99405 5.54442 6.11111 5.26347 6.11111 4.97052C6.11111 4.67757 5.99405 4.39662 5.78567 4.18947C5.5773 3.98232 5.29468 3.86595 5 3.86595C4.70532 3.86595 4.4227 3.98232 4.21433 4.18947C4.00595 4.39662 3.88889 4.67757 3.88889 4.97052C3.88889 5.26347 4.00595 5.54442 4.21433 5.75157C4.4227 5.95871 4.70532 6.07509 5 6.07509Z",
    fill: "#686B7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdLocationIco);
export default __webpack_public_path__ + "static/media/ad_location_ico.c7de5dcdfba88841c202000e120c4d1c.svg";
export { ForwardRef as ReactComponent };